import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-108">
      {/* Background glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-109" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 border border-amber-500/30 rounded-3xl p-8 md:p-12 shadow-2xl text-center relative overflow-hidden" data-id="element-111">
          {/* Top accent line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600" data-id="element-112" />

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-113">
            Reclaim your nights and your mornings for less than the cost of a
            week's worth of lattes.
          </h2>

          <div className="my-10 space-y-2" data-id="element-114">
            <p className="text-slate-400 text-lg line-through decoration-red-500/50 decoration-2" data-id="element-115">
              Total value: $54
            </p>
            <div className="flex items-center justify-center space-x-3" data-id="element-116">
              <span className="text-2xl font-heading text-slate-300" data-id="element-117">
                Your price today:
              </span>
              <span className="text-6xl font-heading font-bold text-amber-500 drop-shadow-glow-amber" data-id="element-118">
                $27
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center space-y-4 max-w-md mx-auto" data-id="element-119">
            <motion.a href="https://wellnesssuccesssystem.com/cart/42808575262797:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="block w-full py-5 bg-amber-500 hover:bg-amber-600 text-navy-900 font-bold text-xl rounded-xl shadow-glow-amber transition-all duration-300 text-center no-underline" data-id="element-120">
              Get Instant Access for $27
            </motion.a>

            <motion.a href="https://wellnesssuccesssystem.com/cart/42808575262797:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full py-4 bg-transparent border-2 border-slate-600 hover:border-slate-400 text-slate-300 font-semibold text-lg rounded-xl transition-colors text-center no-underline" data-id="element-121">
              I'm Ready to Reset My Nights
            </motion.a>
          </div>

          <div className="mt-8 flex items-center justify-center space-x-6 text-sm text-slate-400" data-id="element-122">
            <div className="flex items-center space-x-2" data-id="element-123">
              <LockIcon className="w-4 h-4 text-slate-500" data-id="element-124" />
              <span data-id="element-125">Secure checkout</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-126">
              <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-127" />
              <span data-id="element-128">Instant digital delivery</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}